import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createEpicMiddleware } from 'redux-observable';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import rootEpic from './epics';
import * as ActionTypes from './actions/ActionTypes';


const isDev = (process.env.NODE_ENV === 'development');


export const configureStore = (initialState, dependencies, debug = isDev) => {
    const epicMiddleware = createEpicMiddleware(rootEpic, { dependencies });
    const loggerMiddleware = createLogger({
        collapsed: true,
        colors: {
            action: () => '#03A9F4',
            error: () => '#F20404',
            nextState: () => '#4CAF50',
            prevState: () => '#9E9E9E',
            title: () => '#0074D9',
        },
        duration: true,
        predicate: (getState, action) => action.type !== ActionTypes.PLAYER_EVENT_TIME_UPDATE
            && action.type !== ActionTypes.SET_CURRENT_TIME_STATE
            && action.type !== ActionTypes.ON_VOLUME_CONTROL_MOUSE_OUT
            && action.type !== ActionTypes.ON_VOLUME_CONTROL_MOUSE_OVER
            && action.type !== ActionTypes.HLS_EVENT_LEVEL_LOADED
            && action.type !== ActionTypes.SET_WAITING_STATE
            && action.type !== ActionTypes.PLAYER_EVENT_LOADED_DATA
            && action.type !== ActionTypes.PLAYER_EVENT_WAITING
            && action.type !== ActionTypes.SET_PAUSE_STATE
            && action.type !== ActionTypes.SET_PLAYING_STATE
            && action.type !== ActionTypes.SET_VIDEO_PROGRESS_STATE
    });
    const middleware = debug
        ? applyMiddleware(loggerMiddleware, epicMiddleware)
        : applyMiddleware(epicMiddleware);

    return createStore(
        rootReducer,
        initialState,
        debug ? composeWithDevTools(middleware) : middleware
    );
};


// WEBPACK FOOTER //
// ./src/store.js